module.exports = function getQueryNode(search) {
	const params = new URLSearchParams(search);
	let query_node = params.get("node");
	return query_node ? query_node.split("|") : null;
};
